/** Normalize a stored id that may still be a string into a string array. */
export function asIdList(value: string | string[] | null | undefined): string[] {
    if (value == null) {
        return [];
    }
    return (Array.isArray(value) ? value : [value]).filter(Boolean);
}
